// extracted by mini-css-extract-plugin
export default {"ShipmentDetailsNotificationBanner__text":"ShipmentDetailsNotificationBanner-styles__ShipmentDetailsNotificationBanner__text__MA3N8"};